export const SERVICE_MESSAGE = 'SERVICE_MESSAGE';

export const GIFT_NOTIFICATION = 'gift_notification';
export const WALL_POST_NOTIFICATION = 'wall_post_notification';
export const EXCLUSION_APPLIED_NOTIFICATION = 'exclusion_applied_notification';
export const BAN_NOTIFICATION = 'ban_notification';
export const LOGOUT_NOTIFICATION = 'logout_notification';
export const MEMBER_TYPE_CHANGE_NOTIFICATION = 'member_type_change_notification';
export const PERSONAL_ROOM_ACTIVATED_NOTIFICATION = 'personal_room_activated_notification';
export const SHOWROOM_ACTIVATED_NOTIFICATION = 'showroom_activated_notification';
export const TIP_NOTIFICATION = 'tip_notification';
export const MEMBERSHIP_GIFT_NOTIFICATION = 'membership_gift_notification';
export const USER_UNMUTED_NOTIFICATION = 'user_unmuted';
export const USER_MUTED_NOTIFICATION = 'user_muted';
export const RELOAD_PAGE_NOTIFICATION = 'reload_page';




// WEBPACK FOOTER //
// ./src/constants/serviceMessage.js